<div id="divLineChart">
	<canvas #chartCanvas id="ChartLineComponent" [ngStyle]="{ minWidth: '100%', height: 'auto' }"></canvas>
</div>
